import React from 'react'

import FinePrint from './FinePrint'
import faqStyles from './faq.module.sass'

export default class FAQ extends React.Component {
  render() {
    const { acf, acfOptions } = this.props

    return (
      <div className={faqStyles.faq} ref={this.faqRef}>
        <FinePrint
          className={faqStyles.fineprint}
          acf={acf}
          faq={acfOptions.faq_bistro}
          section="Bistro"
          variant="faq"
        />
        <FinePrint
          className={faqStyles.fineprint}
          acf={acf}
          faq={acfOptions.faq_lodge}
          section="Lodge"
          variant="faq"
        />
        <FinePrint
          className={faqStyles.fineprint}
          acf={acf}
          faq={acfOptions.faq_yoho}
          section="Field &amp; Area"
          variant="faq"
          show_button
        />
      </div>
    )
  }
}
